var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.loading
    ? _c("div", { staticClass: "loading_wrap" }, [_vm._m(0)])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "loading" }, [
      _c("div", { staticClass: "snippet" }, [
        _c("div", { staticClass: "stage" }, [
          _c("div", [_c("div", { staticClass: "dot-flashing" })]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }